export enum RoleType {
  /**
   * Role for application admin with full administrator access
   */
  ADMIN = 'APP_ADMIN',

  /**
   * Role for normal user with basic access
   */
  USER = 'APP_USER',
}

export interface UserInfo {
  id: string;
  email: string;
  name?: string;
  phone?: string;
  role: RoleType;
  pictureUrl: string | null;
  organizerId?: string | null;
  cart?: string[];
}

export interface ChangePassResponse {
  email: string;
  message: string;
  isDefaultPassword: boolean;
}

export interface AdminSignInDto {
  email: string;
  password: string;
}

export interface ChangePassDto extends AdminSignInDto {
  passwordConfirm: string;
}
